import React from 'react';
import moment from 'moment';
import { Radio } from '@blueprintjs/core';

class LichSuTrangThaiXuLyGiaiQuyetDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state ={
      isOpen: true
    }
  }

  handleCollapse() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  showTinhTrangXuLyDon(tinhTrangInfo){
    if (tinhTrangInfo.type === 'DAY') {
      if (tinhTrangInfo.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (tinhTrangInfo.value > 0) {
        return (
          <p>Còn {tinhTrangInfo.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(tinhTrangInfo.value)} ngày</p>
        )
      }
    } else if (tinhTrangInfo.type === 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {tinhTrangInfo.value}</p>
      )
    }
  }

  render() {
    let LichSuTrangThaiXuLyGiaiQuyetDon = '';
    if(this.props.dataLichSuTrangThaiXuLyGiaiQuyetDon) {
      LichSuTrangThaiXuLyGiaiQuyetDon = this.props.dataLichSuTrangThaiXuLyGiaiQuyetDon.map((item,i) => {
        return (
          <div className="history-items" key={i}>
            <div className="radio-column">
              <Radio defaultChecked={ true }/>
            </div>
            <div className="group-val">
              <span className="txt-bold txt-upper">{item.tenInfo.ten ? item.tenInfo.ten : null}</span>
              <span className="val-content">{item.ngayBatDauInfo ? moment(item.ngayBatDauInfo).format('DD/MM/YYYY - HH:mm') : null}</span>
            </div>
            <div className="group-val">
              <span className="txt-bold">Thời hạn:</span>
              <span className="val-content">{item.thoiHanInfo ? moment(item.thoiHanInfo).format('DD/MM/YYYY') : null}</span>
            </div>
            <div className="group-val">
              <span className="txt-bold">Tình trạng:</span>
              <span className="val-content">{item.tinhTrangInfo.status ? item.tinhTrangInfo.status : this.showTinhTrangXuLyDon(item.tinhTrangInfo)}</span>
            </div>
            <div className="group-val">
              <span className="txt-bold">Đơn vị xử lý:</span>
              <span className="val-content">{item.donViXuLyInfo ? item.donViXuLyInfo.ten : null}</span>
            </div>
            <div className="group-val">
              <span className="txt-bold">Người xử lý:</span>
              <span className="val-content">{item.nguoiXuLyInfo ? item.nguoiXuLyInfo.hoVaTen : null}</span>
            </div>
          </div>
        );
      });
    } else {
      LichSuTrangThaiXuLyGiaiQuyetDon = (<div></div>);
    }

    return (
      <div className="box-forward">
        <div className="container-box">
          <div className="group-box">
            <div className="title">
              <div className="rows">
                <div className="col-12">
                  <h3>{this.props.title}</h3>
                </div>
              </div>
            </div>
            <div className="items-form white-table mb20">
              <div className="rows">
                <div className="col-12">
                  <div className="wrap-history wrap-history-cols">
                    {LichSuTrangThaiXuLyGiaiQuyetDon}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LichSuTrangThaiXuLyGiaiQuyetDon;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/LichSuTrangThaiXuLyGiaiQuyetDon.jsx